var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_3700)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_3700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5837 41.8314V36.8772L37.4649 28.0564C37.7066 27.8147 37.9734 27.6335 38.2654 27.5126C38.5574 27.3918 38.8646 27.3314 39.1868 27.3314C39.509 27.3314 39.8161 27.3918 40.1081 27.5126C40.4002 27.6335 40.667 27.8147 40.9087 28.0564L42.3889 29.5668C42.6104 29.8085 42.7816 30.0753 42.9024 30.3673C43.0232 30.6593 43.0837 30.9564 43.0837 31.2585C43.0837 31.5605 43.0182 31.8576 42.8873 32.1496C42.7564 32.4416 42.5802 32.7085 42.3587 32.9501L33.5378 41.8314H28.5837ZM39.1264 32.8293L40.667 31.2585L39.1868 29.748L37.6159 31.3189L39.1264 32.8293ZM29.4899 26.4251L27.7982 24.7033L30.0035 22.498H25.9555C25.7743 23.0217 25.4923 23.4748 25.1097 23.8574C24.7271 24.2401 24.2739 24.522 23.7503 24.7033V34.7928C24.4552 35.0546 25.0342 35.4927 25.4873 36.1069C25.9404 36.7211 26.167 37.421 26.167 38.2064C26.167 39.2133 25.8146 40.0692 25.1097 40.7741C24.4048 41.4789 23.5489 41.8314 22.542 41.8314C21.535 41.8314 20.6791 41.4789 19.9743 40.7741C19.2694 40.0692 18.917 39.2133 18.917 38.2064C18.917 37.421 19.1436 36.7262 19.5967 36.122C20.0498 35.5178 20.6288 35.0849 21.3337 34.823V24.7033C20.6288 24.4414 20.0498 24.0034 19.5967 23.3892C19.1436 22.775 18.917 22.0751 18.917 21.2897C18.917 20.2828 19.2694 19.4269 19.9743 18.722C20.6791 18.0171 21.535 17.6647 22.542 17.6647C23.3274 17.6647 24.0272 17.8913 24.6415 18.3444C25.2557 18.7975 25.6937 19.3765 25.9555 20.0814H30.0035L27.7982 17.8762L29.4899 16.1543L34.6253 21.2897L29.4899 26.4251ZM39.4587 17.6647C40.4656 17.6647 41.3215 18.0171 42.0264 18.722C42.7312 19.4269 43.0837 20.2828 43.0837 21.2897C43.0837 22.2967 42.7312 23.1526 42.0264 23.8574C41.3215 24.5623 40.4656 24.9147 39.4587 24.9147C38.4517 24.9147 37.5958 24.5623 36.891 23.8574C36.1861 23.1526 35.8337 22.2967 35.8337 21.2897C35.8337 20.2828 36.1861 19.4269 36.891 18.722C37.5958 18.0171 38.4517 17.6647 39.4587 17.6647Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_3700",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_3700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_3700",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_3700",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.69c642b9c37b2c8d6aeece8f705a6b02.svg";
export { ForwardRef as ReactComponent };